# frozen_string_literal: true

module Engine
  module Game
    module G1850
    end
  end
end
